import React, { Component } from 'react';
import Proxy from './Common/TTLProxy';
import './App.css';
import { Modal , ModalFooter , ModalBody , ModalHeader , ModalTitle , Navbar , Form , FormGroup } from  'react-bootstrap';
import Validator from 'validator';
import ValidatorExtension from './Common/Validator';

const Styles = {

    inputStyle: {
        padding: '10px'
    },
    errorDisplay:{
        backgroundColor: '#cbcbcb40',
        padding: '5px',
        color: '#e20a09',
        fontSize: 'medium'
    }

};


const ErrorDisplay = (props) => {
    return <div style={Styles.errorDisplay}>{props.hint && <b>{props.hint} </b>}{props.error}</div>
};

//  Testimony section
const Testimony = (props) => {

    return (<section id="fh5co-testimony" data-section="testimony">
        <div className="container">
            <div className="row">
                <div className="col-md-12 to-animate">
                    <div className="wrap-testimony">
                        <h3>The Problem</h3>
                        <p>Majority of farmers who need ploughing services are unable to reach out to the
                            mechanization centers/Tractor services or operators.</p>
                        <p>The few existing mechanization centers (Operators) mostly cannot easily connect to
                            farmers.</p>
                        <p>Tractor owner cannot monitor operation of equipment and are losing out on his
                            investment.</p>
                    </div>
                </div>
            </div>
        </div>
    </section>);
};

//  Header section
const Header = (props) => {
    return (<header role="banner" id="fh5co-header">
        <div className="fluid-container">

            <nav className="navbar navbar-default">
                <div className="navbar-header">
                    <a href="/" className="js-fh5co-nav-toggle fh5co-nav-toggle" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar"><i></i></a>
                    <a href="/"><img src="images/logo_center.png" className="img-logo" style={{padding: 6}}/></a>
                </div>
                <div id="navbar" className="navbar-collapse collapse">
                    <ul className="nav navbar-nav navbar-right">
                        {props.links.map((item,i) =>{
                            return <li className="active" key={i}><a href={item.url || "#"} data-nav-section={item.section} target={item.target}><span>{item.text}</span></a></li>
                        })}
                    </ul>
                </div>
            </nav>
        </div>
    </header>)
};

//  About section
const About = (props) => {

    return (<section id="fh5co-footer" role="contentinfo" data-section="about">
        <div className="container">
            <div className="row">
                <div className="col-md-4 to-animate">
                    <h3 className="section-title">About Us</h3>
                    <p>We are a team of young passionate Africans using internet of things (IoT) and technology to change the lives of smallholder farmers through the provision of platforms which makes agricultural mechanization (Tractor) service available,
                        accessible and affordable to enhance productivity, improve efficiency and reduce post-harvest loss.</p>


                    <h3 className="section-title">Connect with Us</h3>
                    <ul  className="social-media">
                        <li><a href="https://facebook.com/trotrotractor" className="facebook"><i className="icon-facebook"></i></a></li>
                        <li><a href="https://twitter.com/trotrotractor" className="twitter"><i className="icon-twitter"></i></a></li>
                        <li><a href="https://gh.linkedin.com/in/trotrotractor" className="linkedin"><i className="icon-linkedin"></i></a></li>
                    </ul>



                </div>

                <div className="col-md-4 to-animate">
                    <h3 className="section-title">Our Address</h3>
                    <ul className="contact-info">
                        <li><i className="icon-map-marker"></i>19 Banana Avenue, East Legon Accra Ghana</li>
                        <li><i className="icon-phone"></i>+233501583979 / +233501583978 / +233501583982</li>
                        <li><i className="icon-envelope"></i><a href="#">team@trotrotractor.com</a></li>
                    </ul>
                </div>

                <div className="col-md-4 to-animate">
                    <a className="twitter-timeline" href="https://twitter.com/trotrotractor?ref_src=twsrc%5Etfw" data-height="300">Tweets by trotrotractor</a>
                </div>
            </div>
        </div>
    </section>)
};

//  Getting started section
const GettingStarted = (props) => {

    return (<div className="getting-started getting-started-1">
        <div className="container">
            <div className="row">
                <div className="col-md-6 to-animate">
                    <h3>The Solution</h3>
                    <p>This situation presents a huge ready business opportunity to capitalize on. TROTRO Tractor Limited (TTL) is a powerful platform that connects farmers and tractor operators. This platform will also allow tractor owners to monitor movement
                        and work progress of their equipment.</p>
                    <p> On our platform, the farmer will be able to request, schedule and prepay for tractor services. The operator on the other hand gets quick requests for tractors (Ploughing) services.
                    </p>
                </div>
                <div className="col-md-6 to-animate-2">
                    <div className="call-to-action text-right">

                        <a href="http://app.trotrotractor.com" className="sign-up">Sign Up For Free</a>

                    </div>
                </div>
            </div>

            <div>

            </div>

        </div>
    </div>);
};

//  Getting started-2
const GettingStartedEx = (props) =>{

    return (<div className="getting-started getting-started-2">
        <div className="container">
            <div className="row">
                <div className="col-md-6 to-animate">
                    <h3>Getting Started</h3>
                    <p>We are an agricultural technology company that is improving global food and income security by building a network of “TROTRO Tractor” owners that farmers obtain service via SMS. This way, small landowners have access to affordable
                        farm machine services to increase their productivity. </p>
                </div>
                <div className="col-md-6 to-animate-2">
                    <div className="call-to-action text-right">
                        <a href="http://app.trotrotractor.com" className="sign-up">Sign Up For Free</a>
                    </div>
                </div>
            </div>
        </div>
    </div>);

};

//  Trusted sections
const TrustedInfo = ({props}) =>{

   return <section id="fh5co-trusted" data-section="trusted">
        <div className="fh5co-trusted">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 section-heading text-center">
                        <h2 className="to-animate">Trusted By</h2>
                        <div className="row">
                            <div className="col-md-8 col-md-offset-2 subtext">
                                <h3 className="to-animate">We’re trusted by these popular Organizations</h3>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">

                    <div className="col-md-2 col-sm-3 col-xs-6 col-sm-offset-0">
                        <div className="partner-logo to-animate-2">
                            <img src="images/pic04398_lw.jpg" alt="Partners" className="img-responsive"/>
                        </div>
                    </div>

                    <div className="col-md-2 col-sm-3 col-xs-6">
                        <div className="partner-logo to-animate-2">
                            <img src="images/giz-logo.gif" alt="Partners" className="img-responsive"/>
                        </div>
                    </div>

                    <div className="col-md-2 col-sm-3 col-xs-6">
                        <div className="partner-logo to-animate-2">
                            <img src="images/yara.png" alt="Partners" className="img-responsive"/>
                        </div>
                    </div>

                    <div className="col-md-2 col-sm-3 col-xs-6">
                        <div className="partner-logo to-animate-2">
                            <img src="images/logo01.gif" alt="Partners" className="img-responsive"/>
                        </div>
                    </div>
                    <div className="col-md-2 col-sm-3 col-xs-6">
                        <div className="partner-logo to-animate-2">
                            <img src="images/logo6.png" alt="Partners" className="img-responsive"/>
                        </div>
                    </div>

                    <div className="col-md-2 col-sm-12 col-xs-12">
                        <div className="partner-logo to-animate-2">
                            <img src="images/logo.png" alt="Partners" className="img-responsive"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
};

class RegisterTractorRequest extends  React.Component {

    constructor(props){
        super(props);
        this.state = this.getInitialState();
    }

    getInitialState(){

        return {
            isOpen: false
        };

    }

    show(){
        this.setState(this.getInitialState());
        this.toggle();
    }


    toggle(){

        this.setState({
            isOpen: !this.state.isOpen
        });

    }

    render(){

        return <Modal show={this.state.isOpen} onShow={this.toggle.bind(this)} onExit={this.toggle.bind(this)}>
            <ModalHeader closeButton={true}>Request Tractor Service</ModalHeader>
            <ModalBody>

            <hr/>

            <div>

                <Form>

                </Form>

            </div>

            </ModalBody>

        </Modal>
    }

}

class App extends Component {

    //  The Web-API proxy instance
    proxy;

    /**
     * Track analytics data
     * @param key
     * @param data
     */
    static trackAnalytics(key,data){

        //  Enabled analytics
        if(process.env.REACT_APP_ENABLE_ANALYTICS == 'true') {

            const analytics = window.analytics;

            if (analytics) {
                analytics.track(key, data);
            }
        }

    }


    constructor(){
        super();

        this.state = {

            //  SignUp dialog toggle
            showSignUp: false,

            //  SignUp completed successfully
            signUpComplete: false,

            //  Error messages for signup tabs
            signUpErrorMessage: {}
        };

        //
        this.toggleSignUpDialog = this.toggleSignUpDialog.bind(this);

        //  PROXY IMPLEMENTATION UNDER CONSTRUCTION
        //  this.initProxy();
    }

    toggleSignUpDialog(evt){

        if(evt)
            evt.preventDefault();

        const s = !this.state.showSignUp;
        let complete = this.state.signUpComplete;
        let errMsgs = this.state.signUpErrorMessage;

        if(s)
            complete = false;
        else
            errMsgs = {};

        this.setState({
           showSignUp: s,
           signUpComplete: complete,
            signUpErrorMessage: errMsgs
        });

    }


    signUpComplete(){

        this.setState({
            signUpComplete: true
        });

    }

    /**
     * Initializes the web api proxy
     */
    /*initProxy(){

        //  assign proxy reference
        this.proxy = new Proxy(

            //  set api-key
            '3923512968690Tg5o28b87x263Vo7pOP',

            //  set server address.
            'http://localhost:1337',

            //  guest user credentials. Have limited access to API's
            {
                username: 'guest' ,
                password: 'guest.user123@ttl.com'
            }
        );
    }*/


    processSignUp(key , formData , validator ){

        let msg = this.state.signUpErrorMessage;

        try{

            //  clear error first before
            delete msg[key];

            //
            this.setState({
                signUpErrorMessage: msg
            });

            //  validate form
            validator(formData);

            //
            if(process.env.NODE_ENV == 'development'){
                console.dir(formData);
            }

            //  track analytics
            App.trackAnalytics(key, formData );

            //  TODO: Send data to Core-API using proxy

            //  complete registration
            this.signUpComplete();

        }catch(ex){

            msg[key] = ex.message;

            this.setState({
                signUpErrorMessage:  msg
            });

        }

    }

    /**
     * Submit farmer form
     */
    submitFarmer(evt){

        const form = evt.target;
        evt.preventDefault();

        //
        const formData = {
           name: form["name"].value,
           farm_location: form["farm_location"].value,
           phone: form["phone"].value
        };

        this.processSignUp('REGISTER_FARMER' , formData , (formData) =>{

            if(Validator.isEmpty(formData.name) || Validator.isNumeric(formData.name)){
                throw new Error("Please enter a valid name");
            }

            if(!ValidatorExtension.isPhone(formData.phone) || !Validator.isMobilePhone(formData.phone,'any')){
                throw new Error("Please enter a valid phone number");
            }

            if(Validator.isEmpty(formData.farm_location) || Validator.isNumeric(formData.farm_location)){
                throw new Error("Please enter a valid location");
            }
        });

    }

    /**
     * Submit tractor owner form
     */
    submitTractorOwner(evt){

        const form = evt.target;
        evt.preventDefault();

        const formData = {
            name: form["name"].value,
            phone : form["phone"].value,
            location: form["location"].value
        };

        this.processSignUp('REGISTER_TRACTOR_OWNER', formData , (formData) =>{

            if(Validator.isEmpty(formData.name) || Validator.isNumeric(formData.name)){
                throw new Error("Please enter the tractor owner's name");
            }

            if(!ValidatorExtension.isPhone(formData.phone) || !Validator.isMobilePhone(formData.phone,'any')){
                throw new Error("Please enter a valid phone number");
            }

            if(Validator.isEmpty(formData.location) || Validator.isNumeric(formData.location)){
                throw new Error("Please enter a valid location");
            }

        });


    }

    /**
     * Submit Partner form
     */
    submitPartner(evt){

        const form = evt.target;
        evt.preventDefault();

        const formData = {
            name: form["name"].value,
            phone: form["phone"].value,
            location: form["location"].value
        };

        this.processSignUp('REGISTER_PARTNER', formData ,(formData) =>{

            if( Validator.isEmpty(formData.name) || Validator.isNumeric(formData.name)){
                throw new Error("Please enter your name");
            }

            if(!ValidatorExtension.isPhone(formData.phone) || !Validator.isMobilePhone(formData.phone,'any')){
                throw new Error("Please enter a valid phone number");
            }

            if(Validator.isEmpty(formData.location) || Validator.isNumeric(formData.location)){
                throw new Error("Please enter a valid location")
            }

        });

    }

    /**
     * Called to submit an enquiry
     * @param data
     */
    onSubmitEnquiry(data){

        //  Register partner
        App.trackAnalytics('SUBMIT_ENQUIRY', data)

        //  reload page
        window.location.reload();
    }

    renderFormError(key){
        return this.state.signUpErrorMessage[key] && <ErrorDisplay hint="Validation Error:" error={this.state.signUpErrorMessage[key]}/>;
    }

    render() {

        const NavLinks = [
            { section: 'home' , text: 'Home' },
            { section: 'about' , text: 'About Us'}
        ];

        return (
            <div>
                <section data-section="home">
                    <Header links={NavLinks} />

                    <div className="video-background" />

                    <div className="header-content">
                        <h1 className="header-title">Tractor At Your Service in Ghana Like TROTRO...<br/>
                            Dial *714*85#
                        </h1>


                        <div>
                            {/*<a className="btn btn-default header-btn" style={{width: "auto" }} href="http://app.trotrotractor.com">Request Tractor Service</a>*/}
                            <a className="btn btn-default header-btn" href="http://app.trotrotractor.com">Sign Up</a>
                        </div>

                    </div>

                </section>


                <Testimony/>

                <GettingStarted onSignUp={this.toggleSignUpDialog}/>

                <TrustedInfo/>

                <GettingStartedEx onSignUp={this.toggleSignUpDialog}/>

                <About submitEnquiry={this.onSubmitEnquiry.bind(this)}/>

                <RegisterTractorRequest ref={r => this._requestDlg = r} />

                <Modal bsSize={this.state.signUpComplete ? null : "large"} show={this.state.showSignUp} onHide={this.toggleSignUpDialog} dialogTransitionTimeout={0.4} >

                    <ModalHeader closeButton={true}/>

                    <ModalBody>
                        {this.state.signUpComplete ?
                            <div className="ttl-signup-finished">
                                <h3>Thanks for signing up</h3>
                            </div> :

                            <div>

                                <ul className="nav nav-tabs ttl-nav-tabs" role="tablist">
                                    <li role="presentation" className="active ttl-tab"><a href="#farmer" aria-controls="home" role="tab" data-toggle="tab">Farmer</a></li>
                                    <li role="presentation" className="ttl-tab"><a href="#tractor_owner" aria-controls="profile" role="tab" data-toggle="tab">Tractor Owner</a></li>
                                    <li role="presentation" className="ttl-tab"><a href="#partner" aria-controls="messages" role="tab" data-toggle="tab">Partner</a></li>
                                </ul>

                                <div className="tab-content ttl-tab-content">
                                    <div role="tabpanel" className="tab-pane active" id="farmer">
                                        <h2>Farm with us...</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <form className="form-horizontal" role="form" onSubmit={this.submitFarmer.bind(this)}>
                                                    <input name="name" className="form-control ttl-signup-input" type="name"  placeholder="Full Name" style={Styles.inputStyle} required/>
                                                    <input name="phone" className="form-control ttl-signup-input" type="phone" placeholder="Phone Number" style={Styles.inputStyle} required/>
                                                    <input name="farm_location" className="form-control ttl-signup-input" type="text" placeholder="Farm Location" style={Styles.inputStyle} required/>
                                                    {this.renderFormError('REGISTER_FARMER')}
                                                    <button type="submit" className="btn btn-success ttl-signup-btn">Stay Updated</button>
                                                </form>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 ttl-signup-highlights">
                                                <div className="row">
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <img className="ttl-signup-highlight-icon" src="images/icons/tractor.png" alt="tractor" />
                                                    </div>
                                                    <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                                        <h3 className="ttl-highlight-title">Increased Yield</h3>
                                                        <p className="ttl-highlight-body">
                                                            Research shows that tilling a 3 acre farm by tractor increases yield by 20%.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <img className="ttl-signup-highlight-icon" src="images/icons/stopwatch.png" alt="tractor" />
                                                    </div>
                                                    <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                                        <h3 className="ttl-highlight-title">No Hassle</h3>
                                                        <p className="ttl-highlight-body">
                                                            Schedule your tractor months in advance. We guarantee it will arrive in the week you choose, or your money back.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <img className="ttl-signup-highlight-icon" src="images/icons/commerce.png" alt="tractor" />
                                                    </div>
                                                    <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                                        <h3 className="ttl-highlight-title">Pay Less</h3>
                                                        <p className="ttl-highlight-body">
                                                            We pre-arrange a fee per acre with Tractor Owners, since we find them more business, they give us their best price.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" className="tab-pane" id="tractor_owner">
                                        <h2>Expand your wings, for a better gain.</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <form id="tractor_owner_signup_form" className="form-horizontal" role="form" onSubmit={this.submitTractorOwner.bind(this)}>
                                                    <input  className="form-control ttl-signup-input" type="text" name="name" style={Styles.inputStyle} placeholder="Full Name"/>
                                                    <input className="form-control ttl-signup-input" type="phone" name="phone" style={Styles.inputStyle} placeholder="Phone Number"/>
                                                    <input className="form-control ttl-signup-input" type="text" name="location" style={Styles.inputStyle} placeholder="Location"/>
                                                    {this.renderFormError('REGISTER_TRACTOR_OWNER')}
                                                    <button type="submit" className="btn btn-success ttl-signup-btn">Stay Updated</button>
                                                </form>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 ttl-signup-highlights">
                                                <div className="row">
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <img className="ttl-signup-highlight-icon" src="images/icons/world.png" alt="tractor" />
                                                    </div>
                                                    <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                                        <h3 className="ttl-highlight-title">Wider Range</h3>
                                                        <p className="ttl-highlight-body">
                                                            Let us help you expand your customer base.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <img className="ttl-signup-highlight-icon" src="images/icons/stopwatch.png" alt="tractor" />
                                                    </div>
                                                    <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                                        <h3 className="ttl-highlight-title">Efficiency</h3>
                                                        <p className="ttl-highlight-body">
                                                            With GPS tracking and monitoring services. Tractor owners can monitor their tractors via our system with ease.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <img className="ttl-signup-highlight-icon" src="images/icons/commerce.png" alt="tractor" />
                                                    </div>
                                                    <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                                        <h3 className="ttl-highlight-title">Payment made easy</h3>
                                                        <p className="ttl-highlight-body">
                                                            Get payed without any hassle with our mobile money platform.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div role="tabpanel" className="tab-pane" id="partner">
                                        <h2>Push your Products and Services</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <form id="partner_signup_form" className="form-horizontal" role="form" onSubmit={this.submitPartner.bind(this)}>
                                                    <input className="form-control ttl-signup-input" type="text" name="name" style={Styles.inputStyle} placeholder="Full Name"/>
                                                    <input className="form-control ttl-signup-input"  type="phone" name="phone" style={Styles.inputStyle} placeholder="Phone Number"/>
                                                    <input className="form-control ttl-signup-input" type="text" name="location" style={Styles.inputStyle} placeholder="Location"/>
                                                    {this.renderFormError('REGISTER_PARTNER')}
                                                    <button id="partner" type="submit" className="btn btn-success ttl-signup-btn">Stay Updated</button>
                                                </form>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 ttl-signup-highlights">
                                                <div className="row">

                                                    <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                                        <h3 className="ttl-highlight-title"></h3>
                                                        <p className="ttl-highlight-body">

                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <img className="ttl-signup-highlight-icon" src="images/icons/tree.png" alt="tractor" />
                                                    </div>
                                                    <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                                        <h3 className="ttl-highlight-title">Help grow the agriculture industry in Ghana.</h3>
                                                        <p className="ttl-highlight-body">
                                                            We are working towards the same goal as you.
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row">
                                                    <div className="col-xs-2 col-sm-2 col-md-2 col-lg-2">
                                                        <img className="ttl-signup-highlight-icon" src="images/icons/trolley.png" alt="tractor" />
                                                    </div>
                                                    <div className="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                                                        <h3 className="ttl-highlight-title">Find new customers with us!</h3>
                                                        <p className="ttl-highlight-body">
                                                            We are happy to co-list your product.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        }
                    </ModalBody>

                    <ModalFooter>
                        <button type="button" className="btn btn-default" onClick={this.toggleSignUpDialog}>Close</button>
                    </ModalFooter>
                </Modal>

            </div>);

  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js